// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2fLeldp-KPzgMv_zWbpXgL","icon":"_16S2DgCAbfpw20TRMSALoK","active":"zuDc4w5rS-ZcAKSCqIucC"};